import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent {
  @Input() history: any[]; // Recebe o histórico do modal
  @Input() documento: string; // Recebe o documento do modal
  @Output() close = new EventEmitter<void>(); // Emite evento para fechar o modal

  closeModal(): void {
    this.close.emit(); // Emite o evento para fechar o modal
  }

  formatarHistorico(history: any[]): string[] {
    // Formata o histórico para exibição
    return history.map(item => `${item.data} - ${item.descricao}`);
  }
}
